import styles from "./MultiSelectInput.module.css";
import {
  FormField,
  MultiSelect,
  MultiSelectItem,
  SelectOption,
} from "@justworkshr/milo-form";
import { useField, useFormikContext } from "formik";
import { ChangeEvent } from "react";

interface optionType {
  value: string;
  description: string;
}

interface IMultiSelectInputProps {
  name: string;
  label: string;
  placeholder: string;
  options: any;
  required?: boolean;
  message?: string;
  className?: string;
  hiddenOptions?: string[];
  onChange: (event: ChangeEvent<HTMLSelectElement> | MultiSelectItem[]) => void;
  values: string[];
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const MultiSelectInput = ({
  ...props
}: IMultiSelectInputProps): JSX.Element => {
  const {
    name,
    label,
    placeholder,
    options,
    message,
    required = true,
    className,
    hiddenOptions = [],
    onChange,
    values,
    fieldRefs,
  } = props;
  const [, meta] = useField(props);
  const { setFieldTouched } = useFormikContext();

  return (
    <div
      className={`${styles.container} ${className}`}
      ref={(el: HTMLInputElement | null) => {
        if (fieldRefs?.current) {
          fieldRefs.current[name] = el as HTMLInputElement | null;
        }
      }}
    >
      <FormField
        required={required}
        message={message}
        label={label}
        aria-labelledby={!label ? "multi-select-input" : undefined}
        error={meta.touched ? meta.error : ""}
      >
        <MultiSelect
          data-testid={name}
          values={values}
          onChange={onChange}
          onBlur={() => {
            setFieldTouched(name, true);
          }}
          required
        >
          <SelectOption
            data-testid={`${name}-option-${placeholder}`}
            value=""
            disabled
          >
            {placeholder}
          </SelectOption>
          {options &&
            options.map((option: optionType) => {
              return (
                <SelectOption
                  key={option.value}
                  value={option.value}
                  data-testid={`${name}-option-${option.value}`}
                  hidden={hiddenOptions.includes(option.value)}
                >
                  {option.description}
                </SelectOption>
              );
            })}
        </MultiSelect>
      </FormField>
    </div>
  );
};

export default MultiSelectInput;
